export default {
    sheet: {
        title: 'Exemplary user table',
        subject: 'Exemplary user table',
        name: 'User',
        examples: {
            locked: 'no',
            position: 'Position',
            salutation: {
                mr: 'Mr',
                mrs: 'Mrs'
            }
        }
    },
    download: 'Download sample file'
}
